export const getTestId = (value: string) => {
  return (value
    // Replace periods with spaces
    .replace(/\./g, " ")
    // Add a space before any capital letter
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    // Remove "(" and ")" signs
    .replace(/[\(\)]/g, "")
    // Convert to lowercase
    .toLowerCase()
    // Replace spaces with hyphens
    .trim()
    .replace(/\s+/g, "-"));
};
